<template>
    <div class="frameOps">
        <div class="grid-buttons">
            <button class="btnBgLayout" @click="$emit('show-background', eventData)">
                <i class="fas fa-cloud-upload-alt"></i>
                background
            </button>
            <DropdownMenu :buttonClass="['base', 'btnCaptureOps']" :buttonArrowSVG="true">
                <template v-slot:button>
                    <i class="fas fa-photo-video"></i>
                    Capture
                </template>
                <template  #menu="{ closeMenu }">
                    <ul style="margin: 0; padding: 0; list-style: none">
                        <li v-for="(i, idx) in listCature" :key="idx" @click="captureSelectedAndClose(i, idx, closeMenu)">
                            <label :for="'capture'+i.id">
                                <input type="checkbox" :checked="(i.checked>0)" :id="'capture'+i.id" >
                                {{i.name}}
                            </label>
                        </li>
                    </ul>
                </template>
            </DropdownMenu>

        </div>
    </div>
</template>
<script>
import DropdownMenu from '@/core/components/DropdownMenu.vue'
export default {
    components: {
        DropdownMenu,
    },
    name: "frameOps",
    props: {
        captureMain: {
            type: Array,
            default: () => ([]),
        },
        eventData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            captureSelected: [],
            listCature: [
                { id: 'photo', name:"Photo", checked: 0},
                { id: 'video', name:"Video", checked: 0},
            ],
        };
    },
    created(){
        if(this.captureMain && Array.isArray(this.captureMain)){
            console.log('isArray', this.captureMain)
            this.captureSelected = [...this.captureMain];
            console.log(this.eventData.id, 'load captureSelected', this.captureMain);
            // set checked status
            this.listCature.forEach((share, index) => {
                const isExist = this.captureSelected.find(i => i.id === share.id);
                if(isExist===undefined){
                    // No existe → agregar
                    // console.log('No existe → agregar', share, isExist)
                    this.captureSelected.push(share);
                }else{
                    //acutalizar valores
                    this.listCature[index].checked = this.captureSelected[index].checked;
                }
            });
        }else {
            this.captureSelected = this.listCature;
        }
        console.log(this.eventData.id, 'created shareSelected', this.captureSelected);
    },
    methods : {
        hasShare(id) {
            // console.log('Checking share id:', id, this.captureSelected);
            return this.captureSelected.find(i => i === id);
        },
        captureSelectedAndClose(newShare, idx, closeMenu) {
            const valid = this.listCature.find(i => i.id === newShare.id);
            if (valid) {
                if (newShare.checked===0) {
                    // add
                    newShare.checked = 1;
                } else {
                    // remove
                    newShare.checked = 0;
                }
                this.captureSelected[idx] = newShare;
                this.listCature[idx] = this.captureSelected[idx];
            }
            console.log('Current capture:', this.captureSelected);
            // this.$emit('update-capture', this.eventData.id, this.captureSelected);
            // if (typeof closeMenu === 'function') closeMenu();
            // else console.warn('No se pudo cerrar el dropdown', typeof closeMenu);
            let payload = JSON.stringify(this.captureSelected);
			// @ts-ignore
			window.master.post('bRem/setUpdateField', {
				org_id: this.org_id,
				user_id: this.user_id,
				event_id: this.eventData.id,
				field_input: 'event_capture',
				field_value: payload,
			})
			.then((response) => {
				// t.is_loading = false;
				console.log('bRem loaded', response.data);
				// this.getbRem();
			}).catch((error) => {
				// t.is_loading = false;
				console.log(error);
			});
        },
        handleMenuSelect() {
        }
    }
};
</script>
<style lang="scss" >
.frameOps{
    display: flex;
    justify-content: center;
    align-items: center;
    .grid-buttons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
        .btnBgLayout {
            border: 1px solid rgba(0, 0, 0, 0.25);
            padding: 3px 5px;
            box-shadow: none;
            background: #fff;
            border-radius: 1px;
            &:focus {outline:none;}
            &:hover { cursor: pointer;}
        }
        button.base.btnCaptureOps {
            border: 1px solid rgba(0, 0, 0, 0.25);
            padding: 3px 5px;
            border-radius: 1px;
        }
        .dropdown_menu ul li {
            padding: 0px 0px;
            label {
                display: flex;
                align-items: center;
                gap: 5px;
                width: 100%;
                padding: 5px 10px;
                font-size: 12px;
                &:hover {cursor: pointer;}
                i {font-size: 14px;}
            }
        }
    }
}
</style>
